import React from 'react'
import classNames from 'classnames'

import EmptySvg from '_static/img/Empty.svg'
import calculateTextWidth from '_lib/calculate-text-width.js'
import snakeCaseToCamelCase from '_lib/snakeCaseToCamelCase'

import './styles.scss'

const columnsWidth = (columns, data = [], offset = 0) => {
  const result = []
  const ensureMaxWidth = (key, value, font = `normal 400 13px Open Sans`) =>
    (result[key] = Math.min(
      Math.max(result[key] || 0, calculateTextWidth(value, font) - offset),
      750
    ))
  columns.forEach(({ key }) => ensureMaxWidth(key, key, `normal bold 14px Open Sans`))
  data.forEach((item) => {
    columns
      .map((c) => c.key)
      .forEach((key) => {
        ensureMaxWidth(key, item[key])
      })
  })
  return result
}

const GridTable = ({ className, columns = [], data, emptyMessage = 'No data' }) => {
  return (
    <Choose>
      <When condition={columns.length > 0}>
        <div className={classNames('grid-table', className)}>
          <div
            className="grid-table__header"
            style={{
              gridTemplateColumns:
                Object.values(columnsWidth(columns, data, -20)).join('px ') + 'px',
            }}
          >
            <For each="tc" of={columns || []}>
              <div className="grid-table__header-column">{tc.name}</div>
            </For>
          </div>

          <div
            className="grid-table__content"
            style={{
              gridTemplateColumns:
                Object.values(columnsWidth(columns, data, -20)).join('px ') + 'px',
            }}
          >
            <For each="dt" of={data || []}>
              <For each="tc" of={columns || []}>
                <div key={tc.key} className="grid-table__data-item" title={dt[tc.key]}>
                  {dt[tc.key] || dt[snakeCaseToCamelCase(tc.key)]}
                </div>
              </For>
            </For>
          </div>
        </div>
      </When>
      <Otherwise>
        <div className="grid-table__no-data">
          <EmptySvg />
          <span>{emptyMessage}</span>
        </div>
      </Otherwise>
    </Choose>
  )
}

export default GridTable
